export function hasPermission(permission) {
    // return authorization header with jwt token
    let AdminUser = JSON.parse(localStorage.getItem('user'));
    if (Array.isArray(permission)) {
        let exists = false;
        permission.forEach(perm => {
            if (AdminUser && AdminUser.result.token && AdminUser.result.user.role_permissions.includes(perm)) {
                exists = true;
            }
        })
        return exists;
    }
    else if (AdminUser && AdminUser.result.token && AdminUser.result.user.role_permissions.includes(permission)) {
        return true;
    } else {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/helper/hasPermission.jsx